<template>
  <div class="personal">
    <h3>Rocio Perez</h3>
    <div class="data"><strong>{{ $t('about.email') }}:</strong> rociopa9999@gmail.com</div>
    <div class="data"><strong>{{ $t('about.phone') }}:</strong> +52 998 335 8310</div>
    <div class="data"><strong>{{ $t('about.languages') }}:</strong> {{ $t('about.languages.list') }}</div>
    <button class="cv-btn" @click="downloadCV">
      {{ $t('about.download_cv') }}
    </button>
    <br><br>
    <SocialBar />
  </div>
</template>

<script>
import SocialBar from './SocialBar.vue'
import { useI18n } from 'vue-i18n'
import { useLocale } from 'vue-i18n' // For Vue 3 i18n
export default {
  name: 'PersonnalCard',
  components: {
    SocialBar,
  },
  setup() {
    const { locale } = useI18n();

    const downloadCV = () => {
      const lang = locale.value || 'en';
      const fileName = lang === 'es' ? 'CV_ROCIO_PEREZ_ES.pdf' : 'CV_ROCIO_PEREZ_EN.pdf';
      const filePath = `${fileName}`;
      const link = document.createElement('a');
      link.href = filePath;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    };

    return { downloadCV };
  }
}
</script>

<style scoped lang="scss">
@import '@/styles/constants.scss';

.data {
  margin-bottom: 15px;
}
.personal {
  color: map-get($colors, primary);
}
.cv-btn {
  margin-top: 10px;
  padding: 8px 18px;
  border-radius: 8px;
  border: 1px solid map-get($colors, accent);
  background: #fff;
  color: map-get($colors, accent);
  font-weight: 500;
  cursor: pointer;
  box-shadow: 0 2px 8px rgba(0,0,0,0.10), 0 1.5px 2px rgba(0,0,0,0.07);
  transition:
    background 0.2s,
    color 0.2s,
    box-shadow 0.2s;
  &:hover {
    background: map-get($colors, accent);
    color: #fff;
    box-shadow: 0 4px 16px rgba(0,0,0,0.16), 0 2px 4px rgba(0,0,0,0.12);
  }
}
</style>
